import ErrorBoundaryFallback from '@components/ErrorBoundary';
import { useSystemLanguage } from '@contexts/SystemLanguageContext';
import { loadRemoteModule } from '@cw-elements/mfe-setup/load';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { useOrganization } from '@hooks/queries/useOrganization';
import { RootState } from '@redux/reducers';
import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

interface MachineryUploadProps {
  userLanguage: string;
  isOpen: boolean;
  orgId: string | null;
  onClose: () => void;
  userId: string | null;
}

const MachineryUpload = lazy<React.FC<MachineryUploadProps>>(() =>
  loadRemoteModule('connect-files/machinery-upload')
);

const ErrorFallback = () => <ErrorBoundaryFallback />;

export const MachineryFileUploader = () => {
  const { organization } = useOrganization();
  const { baseUser } = useSelector((state: RootState) => state.User);

  const [params, setParams] = useSearchParams();
  const [language] = useSystemLanguage();

  const onClose = () => {
    params.delete('openModal');
    setParams(params);
  };

  const orgId = organization?.id ?? null;
  const userId = baseUser?.id ?? null;

  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <Suspense fallback={<LoadingFallback />}>
        <MachineryUpload
          userLanguage={language}
          isOpen={params.get('openModal') === 'file-upload'}
          orgId={orgId}
          userId={userId}
          onClose={onClose}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

const LoadingFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
